import React from "react";
import { Link, useLocation } from "@reach/router";
import { Col, Container, Row } from "react-bootstrap";

import CourseList from "components/CourseList";
import SubscribeCourseList from "components/SubscribeCourseList";
import { useAppContext, RouteContext } from "libs/contextLib";

import {
  SUBSCRIBED_COURSES_HEADING,
  ALL_COURSES_HEADING,
} from "constants/learn";

import "./learn.scss";

function Learn(props) {
  const { authenticatedUser } = useAppContext();
  const location = useLocation();

  return (
    // Providing domain to all child components since most of them are shared between teach and learn
    // Providing navigate (passed as props by Reach router) to child components to allow relative navigation
    <RouteContext.Provider
      value={{ domain: "learn", navigate: props.navigate }}
    >
      <Container className="learn">
        <Row className="mt-4 mx-1">
          <Col className="heading">{SUBSCRIBED_COURSES_HEADING}</Col>
        </Row>
        {!authenticatedUser ? (
          <Row className="mt-2 mx-1 justify-content-center justify-content-sm-start">
            <Col xs="auto" className="rounded login-text text-dark">
              <Link to={"/login?redirect=" + location.pathname}>Login</Link> to
              view your subscribed courses
            </Col>
          </Row>
        ) : (
          <SubscribeCourseList />
        )}
        <Row className="mt-4 mx-1">
          <Col className="p-0 heading">{ALL_COURSES_HEADING}</Col>
        </Row>
        <CourseList />
      </Container>
    </RouteContext.Provider>
  );
}

export default Learn;
